module.exports = __webpack_public_path__ + "img/77c8ba753a83d1a48cca64a1d9f4ad95.png";